import type { MasterEventDTO } from '@app/interface/subject/subject.interface';

type SubjectInfo = MasterEventDTO['subjectInfo'];

/** True when the event carries a usable portrait: has a preview image and isn't a group-only session. */
const hasPortrait = (event: MasterEventDTO): boolean =>
  Boolean(event.subjectInfo.previewImageUrl) && !event.subjectInfo.isGroupOnlyCaptureSession;

/**
 * `subjectInfo` of the subject's own master event for `jobKey`. In the pre-pic-day flow
 * `jobKey === jobNumber` (JobStore.updateJobData), so this matches directly — deterministic
 * and leak-proof (only ever reads the passed events). Returns undefined when:
 * - `jobKey` is absent, or
 * - no event's `jobNumber` equals `jobKey`
 */
export const masterEventLookByJobKey = (
  masterEvents: MasterEventDTO[] | undefined,
  jobKey?: string | null
): SubjectInfo | undefined => {
  if (!jobKey) return undefined;

  return masterEvents?.find((event) => event.eventType?.jobNumber === jobKey && hasPortrait(event))?.subjectInfo;
};

/** `subjectInfo` of the first non-group-only master event that carries a preview image. */
export const firstMasterEventLook = (masterEvents: MasterEventDTO[] | undefined): SubjectInfo | undefined =>
  masterEvents?.find(hasPortrait)?.subjectInfo;
